import { render, staticRenderFns } from "./ExpandableTextarea.vue?vue&type=template&id=6a8d4bff&"
import script from "./ExpandableTextarea.vue?vue&type=script&lang=js&"
export * from "./ExpandableTextarea.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableTextarea.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExpandableTextarea.vue"
export default component.exports